import {Link, useLocation} from "react-router-dom";
import {categoryChildLinks, type Category} from "@corporatesclub/shared";

type Props = {
  categories: Category[];
  c?: string;
  sub?: string;
  subsub?: string;
};

function childLinks(categories: Category[], c?: string, sub?: string, subsub?: string) {
  return categoryChildLinks(categories, c, sub, subsub);
}

export function CategorySubnavGrid({categories, c, sub, subsub}: Props) {
  const {pathname} = useLocation();
  const links = childLinks(categories, c, sub, subsub);
  if(links.length < 2) return null;
  return (
    <nav className="bx-subcatGrid" aria-label="Subcategories">
      {links.map((link) => {
        const active = pathname === link.url || pathname.startsWith(`${link.url}/`);
        return (
          <Link key={link.url} to={link.url} className={`bx-subcatCard anim${active ? " isActive" : ""}`} aria-current={active ? "page" : undefined}>
            {link.label}
          </Link>
        );
      })}
    </nav>
  );
}
